import React from "react";
import { Container } from 'react-bootstrap';

export default function Contact() {
  return (
    <section className="contact-section" id="contact">
      <Container>
        <h2>Get In Touch</h2>
        <p style={{ color: '#d4d4d4', fontSize: '1.1rem', marginBottom: '2rem' }}>
          Have questions or need assistance? Reach out to us!
        </p>

        <div className="contact-icons">
          <a 
            href="mailto:shireenkhan.412@gmail.com" 
            className="contact-icon"
            title="Email"
          >
            <i className="fa-solid fa-envelope"></i>
          </a>

          <a
            href="https://www.linkedin.com/in/shireen-khan-19b8aa194"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-icon"
            title="LinkedIn"
          >
            <i className="fa-brands fa-linkedin"></i>
          </a>

          <a 
            href="https://github.com/shireenkhan-developer" 
            target="_blank"
            rel="noopener noreferrer"
            className="contact-icon"
            title="GitHub"
          >
            <i className="fa-brands fa-github"></i>
          </a>
        </div>

        <div className="contact-location">
          <i className="fa-solid fa-location-dot" style={{ marginRight: '0.5rem', color: '#c9a961' }}></i>
          Islamabad, Pakistan
        </div>
      </Container>
    </section>
  );
}
